const _ = require("lodash");
export const toScreamingSnakeCase = (str) => {
  return _.chain(str).words().map(_.upperCase).join("_").value();
};
